import type { ReactNode } from 'react';
import type { TeamCapacitySummary } from '../hooks/useTeamCapacities';
import type { CalendarTeam } from './CalendarView';
import { ResourceUtilizationBar } from './ResourceUtilizationBar';

interface GridTeamRowProps {
  team: CalendarTeam;
  summary?: TeamCapacitySummary;
  weekDays: Date[];
  renderCell: (team: CalendarTeam, day: Date) => ReactNode;
}

export function GridTeamRow({ team, summary, weekDays, renderCell }: GridTeamRowProps) {
  return (
    <div
      className="grid border-b border-border last:border-b-0"
      style={{ gridTemplateColumns: `150px repeat(${weekDays.length}, 1fr)` }}
    >
      <div className="p-3 border-r border-border bg-card/50 sticky left-0 z-10">
        <div className="space-y-1.5">
          <div className="text-sm font-medium text-foreground">{team.name}</div>
          {summary && (
            <ResourceUtilizationBar
              utilizationPercent={summary.averageUtilization}
              bookedHours={summary.totalBookedHours}
              availableHours={summary.totalAvailableHours}
            />
          )}
        </div>
      </div>
      {weekDays.map((day) => renderCell(team, day))}
    </div>
  );
}
